module.exports = __webpack_public_path__ + "media/images/mobile-only/logo-wide__white-4030fefa83d246f2c17f9c3fdb75992d.png";